// Vendor imports
const classNames = require('classnames')
const PropTypes = require('prop-types')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const LazyImage = require('client-v2/common/components/lazy-image')
const { userProfileHref } = require('client-v2/common/models/user/actions')

function UserAvatar(props) {
  const src = props.user['photo_url']
  const href = props.href === true
  ? userProfileHref(props.user)
  : props.href
  return tag(LazyImage, {
    className: classNames(
      props.className,
      'UserAvatar'
    ),
    href,
    sources: [src],
    visible: props.visible,
    onClick: props.onClick
  })
}

UserAvatar.propTypes = {
  // Values
  className: PropTypes.string,
  href: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string
  ]),
  user: PropTypes.shape({
    // Works for collections & comments too!
    'photo_url': PropTypes.string.isRequired,
    username: PropTypes.string.isRequired
  }),
  visible: PropTypes.bool,
  // Callbacks
  onClick: PropTypes.func
}

module.exports = UserAvatar
